module.exports = __webpack_public_path__ + "static/media/IconTemplates_-05.6edd73ba.svg";